export function returnData(form) {
  const setupDetails = form.setupDetails[form.setup]?.returnJson() || {};
  return {
    status: 'ARMED',
    brokerage: 'BACKTEST',
    dataSource: form.dataSource,
    accountNumber: 'BACKTEST', //todo get from store,
    instrument: 'stock',
    startPeriod: 'open',
    strategy: 'ALERT', // todo might need extra logic for more complex setups
    goLong: form.goLong,
    goShort: form.goShort,
    setup: form.setup,
    restartSystemOncePositionHasFlattened:
      form.restartSystemOncePositionHasFlattened,
    symbol: form.symbol,
    setupDetails: {
      [form.setup]: setupDetails,
    },
    setupFilters: form.setupFilters,
    startHour: form.startHour,
    startMin: form.startMin,
    savedConfigurationTitle: form.savedConfigurationTitle,
    useSavedConfigTitleForDisplay: false,
    restartSettings: form.restartSettings,
    evaluateQuotes: false,
    watchlistName: form.watchlistName,
  };
}
